"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGridContext = exports.GridContext = void 0;
const react_1 = __importStar(require("react"));
const defaultGridContext = {
    state: {
        data: [],
        headerHeight: 0,
        resizable: false,
        toggleable: false,
        pagination: undefined,
        scrollbarWidth: 0,
        hasVerticalScroll: false,
        availableRowsHeight: 0,
        disabled: false,
        isLoading: false,
        rowHeight: 0,
        selection: undefined,
        hideHeader: false,
        sort: undefined,
        totalRow: {},
        initialScrollTop: 0,
        height: 0,
        layoutWidth: 0,
        isEmpty: false,
        columns: [],
        defaultColumnWidth: 0,
        columnsWidth: {}
    },
    onRowClick: () => { },
    onRowDoubleClick: () => { },
    onRowContextMenu: () => { },
    onSelectionChange: () => { },
    onHeaderSelectionChange: () => { },
    onScroll: () => { },
    onRowSelect: () => { },
    updateResizedColumns: () => { }
};
exports.GridContext = react_1.default.createContext(defaultGridContext);
const useGridContext = () => (0, react_1.useContext)(exports.GridContext);
exports.useGridContext = useGridContext;
class GridProvider extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.updateResizedColumns = (column) => {
            this.setState((state) => Object.assign({}, state, column));
        };
        this.state = {
            resizedColumn: {}
        };
    }
    render() {
        const _a = this.props, { children, onRowClick, onRowDoubleClick, onRowContextMenu, onSelectionChange, onHeaderSelectionChange, onScroll, columnsWidth, onColumnResize } = _a, restProps = __rest(_a, ["children", "onRowClick", "onRowDoubleClick", "onRowContextMenu", "onSelectionChange", "onHeaderSelectionChange", "onScroll", "columnsWidth", "onColumnResize"]);
        const onRowSelect = () => { };
        const ctx = {
            state: Object.assign(Object.assign({}, restProps), { columnsWidth: Object.assign({}, columnsWidth, this.state) }),
            onRowClick,
            onRowDoubleClick,
            onRowContextMenu,
            onSelectionChange,
            onHeaderSelectionChange,
            onScroll,
            onRowSelect,
            updateResizedColumns: this.updateResizedColumns
        };
        return (react_1.default.createElement(exports.GridContext.Provider, { value: Object.assign({}, defaultGridContext, ctx) }, children));
    }
}
exports.default = GridProvider;
//# sourceMappingURL=GridProvider.js.map